import React, { useContext, useState, useEffect, useRef } from "react";
import clsx from "clsx";
import { SubmitBtnContext } from "../../App";
import { CompanyAccountContext } from "../../containers/CompanyProfile";
import {
  Grid,
  Paper,
  Typography,
  Button,
  IconButton,
  TextField,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  RadioGroup,
  Radio,
  Checkbox
} from "@material-ui/core";
import { Formik } from "formik";
import useStyles from "../../styles/companyProfileFormstyle";
import SendOutlinedIcon from "@material-ui/icons/SendOutlined";
import { useTranslation } from "../../langs/useTranslation";
import * as localforage from "localforage";
import { useParams } from "react-router-dom";
import StyledSubmitBtn from "../../components/commons/StyledSubmitBtn";
import "../../../node_modules/noty/lib/noty.css";
import "../../../node_modules/noty/lib/themes/relax.css";
import defaultImage from "../../assets/images/default_image.svg";
import "../../css/avatarEditor.css";
import { createAccountAPI } from "../../apis/createAccountAPI";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import HasPermission from "../../components/commons/HasPermission";
import { roleSelectorDeterminator } from "../../helpers/roleSelectorDeterminator";
import {
  newAccountValueSchema,
  newAccountInitialValues
} from "../../config/formSchema";
import { toast } from "@/helpers/toast"
import CompanyTreeModal from "../CompanyTree/Modal";

const AccountCardForm = props => {
  const classes = useStyles();
  const { company_id } = useParams();
  const { dispatch } = useContext(SubmitBtnContext);
  const { handleCancelCreateAccount, setAccountUpdate } = useContext(
    CompanyAccountContext
  );
  const { t } = useTranslation("accountCenter");
  const [activeStatus, setActiveStatus] = useState(true);
  const [initAvatar, setInitAvatar] = useState(defaultImage);
  // eslint-disable-next-line no-unused-vars
  const [isFormEditable, setIsFormEditable] = useState(true);
  const [isFileSizeError, setIsFileSizeError] = useState(false);
  const [roleArr, setRoleArr] = useState([]);
  const [companyTreeModalOpen, setCompanyTreeModalOpen] = useState(false);
  const [passwordValues, setPasswordValues] = useState({
    password: "",
    showPassword: false
  });
  const [invisibleCompanies, setInvisibleCompanies] = useState([]);

  const handleClickShowPassword = () => {
    setPasswordValues({
      ...passwordValues,
      showPassword: !passwordValues.showPassword
    });
  };

  const handleMouseDownPassword = event => {
    event.preventDefault();
  };

  const getRoleOptions = async () => {
    const roles = await roleSelectorDeterminator(company_id);
    setRoleArr(roles);
  };

  const handleShowCompanyTreeModal = () => {
    setCompanyTreeModalOpen(true);
  };

  const handleCompanyConfirm = (checkedCompanyId, excludeCompanyId) => {
    setInvisibleCompanies(excludeCompanyId);
  };

  const inputCursorStyle = !isFormEditable ? {} : { cursor: "pointer" };

  useEffect(() => {
    getRoleOptions();
  }, []);

  return (
    <HasPermission permission="create_account">
      <Grid
        item
        xl={3}
        lg={4}
        md={6}
        sm={12}
        xs={12}
        className={classes.accountCardWrap}
      >
        <Paper elevation={0} className={classes.paper}>
          <Formik
            initialValues={newAccountInitialValues}
            validationSchema={newAccountValueSchema}
            onSubmit={async (values, { setSubmitting }) => {
              try {
                setSubmitting(true);
                dispatch({ type: "showLoading" });
                await createAccountAPI(
                  company_id,
                  invisibleCompanies,
                  values,
                  activeStatus
                );
                handleCancelCreateAccount();
                toast.success(
                  t("companyProfileForm.successfullyUpdateCompany"),
                  {
                    afterClose: function () {
                      setAccountUpdate(true);
                    }
                  }
                );
              } finally {
                dispatch({ type: "stopLoading" });
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue
            }) => (
              <form
                onSubmit={handleSubmit}
                className={`${classes.mainContent} ${classes.mainContent2}`}
              >
                <div className={classes.avatarUploaderWrap}>
                  <div className="avatar-editor">
                    <input
                      type="file"
                      onChange={event => {
                        setIsFileSizeError(false);
                        if (event.target.files && event.target.files[0]) {
                          const src = URL.createObjectURL(
                            event.target.files[0]
                          ); // set src to blob url
                          // const fileName =  event.target.files[0].name;
                          const fileSize =
                            event.target.files[0].size / 1024 / 1024;
                          if (fileSize > 0.5) {
                            setIsFileSizeError(true);
                            return;
                          } else {
                            setIsFileSizeError(false);
                          }
                          setFieldValue("file", event.currentTarget.files);
                          setInitAvatar(src);
                        }
                      }}
                      disabled={isSubmitting}
                      style={inputCursorStyle}
                    />
                    <div className="avatar-image">
                      <img src={initAvatar} alt="avatar" />
                    </div>
                  </div>
                  <div style={{ marginLeft: 12 }}>
                    <Typography variant="caption" color="secondary">
                      {t("companyProfileForm.imageSize")}
                    </Typography>
                    <Typography variant="caption" color="secondary">
                      {t("companyProfileForm.imageFormat")}
                    </Typography>
                    {isFileSizeError ? (
                      <Typography variant="caption" color="error">
                        Please upload file within 500 KB.
                      </Typography>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <TextField
                  className={classes.nameTexField}
                  variant="standard"
                  placeholder="name *"
                  name="name"
                  value={values.name}
                  onChange={handleChange}
                  disabled={isSubmitting}
                  onBlur={handleBlur}
                  helperText={errors.name && touched.name && errors.name}
                  error={!!(errors.name && touched.name && errors.name)}
                />
                <TextField
                  placeholder="Phone *"
                  name="phone"
                  value={values.phone}
                  onChange={handleChange}
                  disabled={isSubmitting}
                  onBlur={handleBlur}
                  helperText={errors.phone && touched.phone && errors.phone}
                  error={!!(errors.phone && touched.phone && errors.phone)}
                />
                <TextField
                  placeholder="Email *"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  disabled={isSubmitting}
                  onBlur={handleBlur}
                  helperText={errors.email && touched.email && errors.email}
                  error={!!(errors.email && touched.email && errors.email)}
                />
                <TextField
                  select
                  SelectProps={{
                    native: true
                  }}
                  name="role"
                  value={values.role}
                  onChange={handleChange}
                  disabled={isSubmitting}
                  className={clsx({
                    [classes.roleSelection]: !values.role,
                    [classes.roleSelected]: values.role
                  })}
                  onBlur={handleBlur}
                  helperText={errors.role && touched.role && errors.role}
                  error={!!(errors.role && touched.role && errors.role)}
                >
                  <option value={null}>Select a role *</option>
                  {roleArr.map(role => {
                    return (
                      <option key={role.id} value={role.id}>
                        {role.name}
                      </option>
                    );
                  })}
                </TextField>
                {/* <HasPermission permission="edit_account_password"> */}
                <div className={classes.passwordWrap}>
                  <TextField
                    placeholder="Password *"
                    name="password"
                    type={passwordValues.showPassword ? "text" : "password"}
                    value={values.password}
                    onChange={handleChange}
                    disabled={isSubmitting}
                    onBlur={handleBlur}
                    helperText={
                      errors.password && touched.password && errors.password
                    }
                    error={
                      !!(errors.password && touched.password && errors.password)
                    }
                  />
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    disabled={isSubmitting}
                  >
                    {passwordValues.showPassword ? (
                      <Visibility />
                    ) : (
                      <VisibilityOff />
                    )}
                  </IconButton>
                  <Typography variant="caption" color="textSecondary">
                    {t("accountProfile.thePasswordMustBeAtLeast8Characters")}
                  </Typography>
                </div>
                {/* </HasPermission> */}
                <HasPermission permission="edit_account_company_mapping">
                  <TextField
                    className={classes.nameTexField}
                    variant="standard"
                    readOnly
                    value={t({ defaultMessage: "公司数据权限配置" })}
                    onClick={handleShowCompanyTreeModal}
                  />
                </HasPermission>
                <FormControl
                  className={`${classes.activeStatus} ${classes.activeStatusEditable}`}
                >
                  <HasPermission permission="active_account">
                    <FormLabel className={classes.formLabel}>{t("accountProfile.active")}</FormLabel>
                      <FormControlLabel
                        name="active"
                        value={values.active}
                        onChange={handleChange}
                        disabled={isSubmitting}
                        control={
                          <Checkbox
                            color="primary"
                            onClick={event => {
                              setActiveStatus(!activeStatus);
                            }}
                            checked={activeStatus}
                          />
                        }
                      />
                  </HasPermission>
                  <FormLabel className={classes.formLabel}>{t("accountProfile.2FA")}
                  </FormLabel>
                  <FormControlLabel
                    name="otp_required"
                    onChange={handleChange}
                    disabled={isSubmitting}
                    control={
                      <Checkbox checked={values.otp_required} color="primary" />
                    }
                    value={values.otp_required}
                  />
                  <FormHelperText
                    hidden={!(errors.active && touched.active && errors.active)}
                    error={!!(errors.active && touched.active && errors.active)}
                  >
                    {errors.active && touched.active && errors.active}
                  </FormHelperText>
                </FormControl>
                <div className={classes.buttonGroup}>
                  <StyledSubmitBtn
                    btnColor="primary"
                    variant="text"
                    startIcon={<SendOutlinedIcon color="primary" />}
                    disabled={isSubmitting}
                    btnText={t("companyProfileForm.confirmBtn")}
                  />
                  <Button
                    type="button"
                    // color="secondary"
                    onClick={props.handleCancelCreateAccount}
                    disabled={isSubmitting}
                  >
                    {t("companyProfileForm.cancelBtn")}
                  </Button>
                </div>
              </form>
            )}
          </Formik>
        </Paper>
      </Grid>
      <CompanyTreeModal
        open={companyTreeModalOpen}
        companyId={company_id}
        useParamId
        excludeKeys={invisibleCompanies}
        onClose={() => setCompanyTreeModalOpen(false)}
        onConfirm={handleCompanyConfirm}
      />
    </HasPermission>
  );
};

export default AccountCardForm;
